import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  input[type="text"],
  input[type="email"] {
    border-radius: 0;
  }

  body #CybotCookiebotDialog {
    padding: 15px 0;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
    box-shadow: none;
  }

  body #CybotCookiebotDialog a,body #CybotCookiebotDialog div {
    font-family: FuturaPT-Book;
  }

  body #CybotCookiebotDialog #CybotCookiebotDialogBodyContentTitle,body #CybotCookiebotDialog #CybotCookiebotDialogBodyButtonDetails,body #CybotCookiebotDialog #CybotCookiebotDialogDetailBodyContentTabs a,body #CybotCookiebotDialog #CybotCookiebotDialogDetailBodyContentCookieContainerTypes a,body #CybotCookiebotDialog #CybotCookiebotDialogDetailFooter {
    font-family: FuturaPT-Book;
  }

  body #CybotCookiebotDialog #CybotCookiebotDialogBody,body #CybotCookiebotDialog #CybotCookiebotDialogDetailBody {
    max-width: 95%;
  }

  body #CybotCookiebotDialog #CybotCookiebotDialogBodyContent {
    min-height: 0;
    padding-top: 0;
    padding-bottom: 10px;
  }

  body #CybotCookiebotDialog #CybotCookiebotDialogBodyContentTitle {
    display: none;
  }

  body #CybotCookiebotDialog #CybotCookiebotDialogBodyContentText a {
    color: #C79F27;
  }

  body #CybotCookiebotDialog #CybotCookiebotDialogBodyButtons {
    align-items: center;
    display: flex;
    gap: 6px;
    margin-bottom: 0;
  }

  @media (min-width: 768px) {
    body #CybotCookiebotDialog #CybotCookiebotDialogBodyButtons {
      gap: 12px;
    }
  }

  body #CybotCookiebotDialog a.CybotCookiebotDialogBodyButton {
    background: #C79F27;
    padding: .7em;
    border: 1px solid transparent;
    color: #FFF;
    font-size: 10px;
    font-family: FuturaPT-Book;
    text-transform: uppercase;
    text-decoration: none;
    text-align: center;
    display: inline-block;
    margin: 0 !important;
    width: auto !important;
  }

  @media (min-width: 768px) {
    body #CybotCookiebotDialog a.CybotCookiebotDialogBodyButton {
      padding: .7em 1.5em;
    }
  }

  body #CybotCookiebotDialog #CybotCookiebotDialogBodyButtonDecline {
    background: #999;
    order: 1;
  }

  body #CybotCookiebotDialog #CybotCookiebotDialogBodyButtonAccept {
    order: 0;
  }

  body #CybotCookiebotDialog #CybotCookiebotDialogBodyButtonDetails {
    order: 2;
    margin: 0 !important;
    padding: 8px 20px 8px 0;
    text-transform: uppercase;
    float: none;
    font-size: 12px;
    white-space: nowrap;
  }

  body #CybotCookiebotDialog #CybotCookiebotDialogDetail {
    padding-top: 15px;
  }

  body > div > #CookieDeclaration,
  body > div > .CookieDeclaration {
    display: none;
  }

  #main .CookieDeclaration {
    display: none;
  }

  #main .basic-page-body .CookieDeclaration {
    display: block;
  }
`;

export default GlobalStyle;
